import axios from "axios"
import Cookies from "universal-cookie"
import {
  STATE_CONTRIBUTOR_TOKEN_APIKEY,
  STATE_CONTRIBUTOR_APIKEY,
} from "../constants/api-constants"

export const getTokenContributor = axios.create()
const cookies = new Cookies()
getTokenContributor.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config
    // Error
    const {
      response: { status },
    } = error

    if (status === 403 || status === 401) {
      // Unauthorized request: maybe access token has expired!
      return refreshAccessToken(originalRequest)
    } else {
      return Promise.reject(error)
    }
  },
)

const refreshAccessToken = async (_originalRequest) => {
  try {
    _originalRequest._retry = true
    await getToken(_originalRequest)
  } catch (error) {
    console.log(error)
  }
}

const getToken = async (_originalRequest) => {
  const token = cookies.get("token")
  const config = {
    headers: {
      apikey: `${STATE_CONTRIBUTOR_TOKEN_APIKEY}`,
    },
  }
  const data = { action: "getJWT" }

  try {
    const response = await axios.post(`${token}`, data, config)
    if (response.status === 200) {
      _originalRequest.headers.Authorization = `Bearer ${response.data.data.id_token}`
      _originalRequest.headers.apikey = `${STATE_CONTRIBUTOR_APIKEY}`
      return _originalRequest
    }
    // console.log("New access token", data)
  } catch (error) {
    console.log(error)
  }
}
